var _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 108,
    fill: "none",
    viewBox: "0 0 109 108",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#507a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#508b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.072.072h-3.366v3.366h3.366zM43.609.072h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877.072h-3.366v3.366h3.366zM59.95.072h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219.072h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.487.072h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756.072h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024.072h-3.366v3.366h3.366zM79.56.072h-3.366v3.366h3.367zM33.804 3.34h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 3.34h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 3.34h-3.366v3.367h3.366zM46.877 3.34h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 3.34H46.78v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 3.34h-3.367v3.367h3.367zM59.95 3.34h-3.366v3.367h3.366zM69.756 3.34h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 3.34h-3.366v3.367h3.366zM82.829 3.34h-3.366v3.367h3.366zM30.535 6.609H27.17v3.366h3.366zM37.072 6.609h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 6.609h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 6.609h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 6.609h-3.366v3.366h3.366zM53.414 6.609h-3.367v3.366h3.367zM59.95 6.609h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 6.609h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.487 6.609h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 6.609h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 6.609h-3.366v3.366h3.366zM79.56 6.609h-3.366v3.366h3.367zM30.535 9.877H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 9.877h-3.367v3.366h3.367zM50.145 9.877H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 9.877h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 9.877h-3.366v3.366h3.366zM66.487 9.877h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 9.877h-3.367v3.366h3.367zM79.56 9.877h-3.366v3.366h3.367zM30.535 13.145H27.17v3.367h3.366zM37.072 13.145h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 13.145h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 13.145h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 13.145h-3.366v3.367h3.366zM53.414 13.145h-3.367v3.367h3.367zM59.95 13.145h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 13.145h-3.367v3.367h3.367zM73.024 13.145h-3.366v3.367h3.366zM82.829 13.145h-3.366v3.367h3.366zM30.535 16.414H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 16.414h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 16.414h-3.366v3.366h3.366zM46.877 16.414h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 16.414H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 16.414h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 16.414h-3.366v3.366h3.366zM69.756 16.414h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 16.414h-3.366v3.366h3.366zM82.829 16.414h-3.366v3.366h3.366zM30.535 19.682H27.17v3.367h3.366zM37.072 19.682h-3.366v3.367h3.366zM43.609 19.682h-3.367v3.367h3.367zM50.145 19.682H46.78v3.367h3.366zM56.682 19.682h-3.366v3.367h3.366zM63.219 19.682h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 19.682h-3.367v3.367h3.367zM76.292 19.682h-3.366v3.367h3.366zM82.829 19.682h-3.366v3.367h3.366zM30.535 22.95H27.17v3.367h3.366zM50.145 22.95H46.78v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 22.95h-3.367v3.367h3.367zM73.024 22.95h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.292 22.95h-3.366v3.367h3.366zM4.388 26.219H1.022v3.366h3.366zM10.925 26.219H7.559v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.193 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.462 26.219h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 26.219h-3.367v3.366h3.366zM40.34 26.219h-3.366v3.366h3.366zM46.877 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 26.219H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 26.219h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 26.219h-3.367v3.366h3.367zM76.292 26.219h-3.366v3.366h3.366zM82.829 26.219h-3.366v3.366h3.366zM89.366 26.219h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 26.219h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 26.219h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 26.219h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 26.219h-3.366v3.366h3.366zM7.657 29.487H4.29v3.367h3.367zM14.193 29.487h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.462 29.487h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 29.487h-3.366v3.367h3.366zM56.682 29.487h-3.366v3.367h3.366zM63.219 29.487h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.487 29.487h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 29.487h-3.367v3.367h3.367zM76.292 29.487h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 29.487h-3.366v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 29.487h-3.366v3.367h3.366zM89.366 29.487h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 29.487h-3.366v3.367h3.366zM99.17 29.487h-3.365v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 29.487h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 29.487h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 29.487h-3.366v3.367h3.366zM7.657 32.756H4.29v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.925 32.756H7.559v3.366h3.366zM17.462 32.756h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 32.756h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 32.756h-3.367v3.366h3.366zM30.535 32.756H27.17v3.366h3.366zM43.609 32.756h-3.367v3.366h3.367zM53.414 32.756h-3.367v3.366h3.367zM63.219 32.756h-3.367v3.366h3.367zM69.756 32.756h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 32.756h-3.366v3.366h3.366zM86.098 32.756H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 32.756h-3.367v3.366h3.367zM95.903 32.756h-3.367v3.366h3.367zM102.439 32.756h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 32.756h-3.367v3.366h3.367zM4.388 36.024H1.022v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.657 36.024H4.29v3.366h3.367zM14.193 36.024h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.462 36.024h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 36.024h-3.366v3.366h3.366zM27.267 36.024H23.9v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.535 36.024H27.17v3.366h3.366zM37.072 36.024h-3.366v3.366h3.366zM50.145 36.024H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 36.024h-3.367v3.366h3.367zM66.487 36.024h-3.366v3.366h3.366zM79.56 36.024h-3.366v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 36.024h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 36.024H82.73v3.366h3.367zM95.903 36.024h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 36.024h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 36.024h-3.366v3.366h3.366zM4.388 39.292H1.022v3.367h3.366zM10.925 39.292H7.559v3.367h3.366zM17.462 39.292h-3.367v3.367h3.367zM23.999 39.292h-3.367v3.367h3.366zM33.804 39.292h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 39.292h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 39.292h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 39.292h-3.367v3.367h3.367zM53.414 39.292h-3.367v3.367h3.367zM63.219 39.292h-3.367v3.367h3.367zM73.024 39.292h-3.366v3.367h3.366zM82.829 39.292h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 39.292H82.73v3.367h3.367zM92.634 39.292h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 39.292h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 39.292h-3.365v3.367h3.366zM4.388 42.56H1.022v3.367h3.366zM10.925 42.56H7.559v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.193 42.56h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.462 42.56h-3.367v3.367h3.367zM37.072 42.56h-3.366v3.367h3.366zM50.145 42.56H46.78v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 42.56h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 42.56h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 42.56h-3.366v3.367h3.366zM69.756 42.56h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 42.56h-3.366v3.367h3.366zM79.56 42.56h-3.366v3.367h3.367zM89.366 42.56h-3.367v3.367h3.367zM102.439 42.56h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 42.56h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 42.56h-3.366v3.367h3.366zM4.388 45.83H1.022v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.657 45.83H4.29v3.366h3.367zM17.462 45.83h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 45.83h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 45.83h-3.367v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.267 45.83H23.9v3.366h3.366zM33.804 45.83h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 45.83h-3.366v3.366h3.366zM43.609 45.83h-3.367v3.366h3.367zM50.145 45.83H46.78v3.366h3.366zM59.95 45.83h-3.366v3.366h3.366zM66.487 45.83h-3.366v3.366h3.366zM73.024 45.83h-3.366v3.366h3.366zM86.098 45.83H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 45.83h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 45.83h-3.366v3.366h3.366zM105.708 45.83h-3.367v3.366h3.367zM10.925 49.098H7.559v3.366h3.366zM17.462 49.098h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 49.098h-3.366v3.366h3.366zM27.267 49.098H23.9v3.366h3.366zM37.072 49.098h-3.366v3.366h3.366zM46.877 49.098h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 49.098H46.78v3.366h3.366zM56.682 49.098h-3.366v3.366h3.366zM66.487 49.098h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 49.098h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 49.098h-3.366v3.366h3.366zM82.829 49.098h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 49.098H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 49.098h-3.367v3.366h3.367zM95.903 49.098h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 49.098h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 49.098h-3.366v3.366h3.366zM7.657 52.366H4.29v3.366h3.367zM17.462 52.366h-3.367v3.366h3.367zM23.999 52.366h-3.367v3.366h3.366zM33.804 52.366h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 52.366h-3.366v3.366h3.366zM46.877 52.366h-3.366v3.366h3.366zM56.682 52.366h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 52.366h-3.366v3.366h3.366zM66.487 52.366h-3.366v3.366h3.366zM76.292 52.366h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 52.366h-3.366v3.366h3.367zM86.098 52.366H82.73v3.366h3.367zM92.634 52.366h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 52.366h-3.367v3.366h3.367zM108.976 52.366h-3.366v3.366h3.366zM4.388 55.634H1.022v3.367h3.366zM14.193 55.634h-3.366v3.367h3.366zM33.804 55.634h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 55.634h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 55.634H46.78v3.367h3.366zM56.682 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 55.634h-3.366v3.367h3.366zM66.487 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 55.634h-3.367v3.367h3.367zM76.292 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 55.634h-3.366v3.367h3.367zM89.366 55.634h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 55.634h-3.366v3.367h3.366zM99.17 55.634h-3.365v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 55.634h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 55.634h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 55.634h-3.366v3.367h3.366zM7.657 58.903H4.29v3.366h3.367zM14.193 58.903h-3.366v3.366h3.366zM20.73 58.903h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 58.903h-3.367v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.267 58.903H23.9v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.535 58.903H27.17v3.366h3.366zM37.072 58.903h-3.366v3.366h3.366zM43.609 58.903h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 58.903h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 58.903H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 58.903h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 58.903h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.95 58.903h-3.366v3.366h3.366zM76.292 58.903h-3.366v3.366h3.366zM82.829 58.903h-3.366v3.366h3.366zM92.634 58.903h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 58.903h-3.367v3.366h3.367zM102.439 58.903h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 58.903h-3.367v3.366h3.367zM7.657 62.171H4.29v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.925 62.171H7.559v3.366h3.366zM30.535 62.171H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 62.171h-3.367v3.366h3.367zM43.609 62.171h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 62.171h-3.366v3.366h3.366zM53.414 62.171h-3.367v3.366h3.367zM59.95 62.171h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 62.171h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.487 62.171h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 62.171h-3.367v3.366h3.367zM76.292 62.171h-3.366v3.366h3.366zM82.829 62.171h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 62.171H82.73v3.366h3.367zM92.634 62.171h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 62.171h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 62.171h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 62.171h-3.366v3.366h3.366zM4.388 65.44H1.022v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.657 65.44H4.29v3.366h3.367zM17.462 65.44h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 65.44h-3.367v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.267 65.44H23.9v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.535 65.44H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 65.44h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 65.44h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 65.44H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 65.44h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 65.44h-3.366v3.366h3.366zM66.487 65.44h-3.366v3.366h3.366zM76.292 65.44h-3.366v3.366h3.366zM82.829 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 65.44H82.73v3.366h3.367zM92.634 65.44h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 65.44h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 65.44h-3.365v3.366h3.366zM4.388 68.708H1.022v3.366h3.366zM20.73 68.708h-3.366v3.366h3.366zM27.267 68.708H23.9v3.366h3.366zM37.072 68.708h-3.366v3.366h3.366zM43.609 68.708h-3.367v3.366h3.367zM53.414 68.708h-3.367v3.366h3.367zM63.219 68.708h-3.367v3.366h3.367zM73.024 68.708h-3.366v3.366h3.366zM79.56 68.708h-3.366v3.366h3.367zM86.098 68.708H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 68.708h-3.367v3.366h3.367zM99.17 68.708h-3.365v3.366h3.366zM108.976 68.708h-3.366v3.366h3.366zM4.388 71.976H1.022v3.366h3.366zM17.462 71.976h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.73 71.976h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999 71.976h-3.367v3.366h3.366zM33.804 71.976h-3.367v3.366h3.367zM40.34 71.976h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 71.976h-3.367v3.366h3.367zM50.145 71.976H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 71.976h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 71.976h-3.366v3.366h3.366zM69.756 71.976h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 71.976h-3.366v3.366h3.366zM99.17 71.976h-3.365v3.366h3.366zM105.708 71.976h-3.367v3.366h3.367zM4.388 75.244H1.022v3.367h3.366zM10.925 75.244H7.559v3.367h3.366zM20.73 75.244h-3.366v3.367h3.366zM30.535 75.244H27.17v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 75.244h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 75.244h-3.366v3.367h3.366zM43.609 75.244h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 75.244h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 75.244H46.78v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 75.244h-3.367v3.367h3.367zM66.487 75.244h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 75.244h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 75.244h-3.366v3.367h3.366zM79.56 75.244h-3.366v3.367h3.367zM86.098 75.244H82.73v3.367h3.367zM92.634 75.244h-3.366v3.367h3.366zM99.17 75.244h-3.365v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 75.244h-3.366v3.367h3.366zM4.388 78.513H1.022v3.366h3.366zM10.925 78.513H7.559v3.366h3.366zM17.462 78.513h-3.367v3.366h3.367zM23.999 78.513h-3.367v3.366h3.366zM30.535 78.513H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 78.513h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 78.513h-3.366v3.366h3.366zM46.877 78.513h-3.366v3.366h3.366zM53.414 78.513h-3.367v3.366h3.367zM59.95 78.513h-3.366v3.366h3.366zM76.292 78.513h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 78.513h-3.366v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 78.513h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 78.513H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 78.513h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 78.513h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 78.513h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 78.513h-3.365v3.366h3.366zM105.708 78.513h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 78.513h-3.366v3.366h3.366zM30.535 81.781H27.17v3.366h3.366zM37.072 81.781h-3.366v3.366h3.366zM56.682 81.781h-3.366v3.366h3.366zM66.487 81.781h-3.366v3.366h3.366zM79.56 81.781h-3.366v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 81.781h-3.366v3.366h3.366zM95.903 81.781h-3.367v3.366h3.367zM102.439 81.781h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 81.781h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.976 81.781h-3.366v3.366h3.366zM50.145 85.05H46.78v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.414 85.05h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 85.05h-3.366v3.366h3.366zM63.219 85.05h-3.367v3.366h3.367zM69.756 85.05h-3.367v3.366h3.367zM76.292 85.05h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 85.05h-3.366v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 85.05h-3.366v3.366h3.366zM89.366 85.05h-3.367v3.366h3.367zM95.903 85.05h-3.367v3.366h3.367zM102.439 85.05h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 85.05h-3.367v3.366h3.367zM30.535 88.318H27.17v3.366h3.366zM37.072 88.318h-3.366v3.366h3.366zM43.609 88.318h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 88.318h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 88.318H46.78v3.366h3.366zM56.682 88.318h-3.366v3.366h3.366zM69.756 88.318h-3.367v3.366h3.367zM76.292 88.318h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.56 88.318h-3.366v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.829 88.318h-3.366v3.366h3.366zM95.903 88.318h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 88.318h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 88.318h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.708 88.318h-3.367v3.366h3.367zM30.535 91.586H27.17v3.367h3.366zM37.072 91.586h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 91.586h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 91.586h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 91.586h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 91.586H46.78v3.367h3.366zM63.219 91.586h-3.367v3.367h3.367zM69.756 91.586h-3.367v3.367h3.367zM76.292 91.586h-3.366v3.367h3.366zM82.829 91.586h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 91.586H82.73v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 91.586h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 91.586h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.903 91.586h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 91.586h-3.365v3.367h3.366zM30.535 94.855H27.17v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.804 94.855h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.072 94.855h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.34 94.855h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 94.855h-3.367v3.366h3.367zM53.414 94.855h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.682 94.855h-3.366v3.366h3.366zM66.487 94.855h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.756 94.855h-3.367v3.366h3.367zM82.829 94.855h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 94.855H82.73v3.366h3.367zM95.903 94.855h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 94.855h-3.365v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 94.855h-3.366v3.366h3.366zM108.976 94.855h-3.366v3.366h3.366zM30.535 98.123H27.17v3.366h3.366zM37.072 98.123h-3.366v3.366h3.366zM46.877 98.123h-3.366v3.366h3.366zM59.95 98.123h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 98.123h-3.367v3.366h3.367zM69.756 98.123h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.024 98.123h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.292 98.123h-3.366v3.366h3.366zM82.829 98.123h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.098 98.123H82.73v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.366 98.123h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.634 98.123h-3.366v3.366h3.366zM33.804 101.391h-3.367v3.367h3.367zM40.34 101.391h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.609 101.391h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.877 101.391h-3.366v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.145 101.391H46.78v3.367h3.366zM56.682 101.391h-3.366v3.367h3.366zM73.024 101.391h-3.366v3.367h3.366zM89.366 101.391h-3.367v3.367h3.367zM95.903 101.391h-3.367v3.367h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17 101.391h-3.365v3.367h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.439 101.391h-3.366v3.367h3.366zM30.535 104.66H27.17v3.366h3.366zM37.072 104.66h-3.366v3.366h3.366zM43.609 104.66h-3.367v3.366h3.367zM50.145 104.66H46.78v3.366h3.366zM59.95 104.66h-3.366v3.366h3.366z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.219 104.66h-3.367v3.366h3.367z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.487 104.66h-3.366v3.366h3.366zM76.292 104.66h-3.366v3.366h3.366zM82.829 104.66h-3.366v3.366h3.366zM92.634 104.66h-3.366v3.366h3.366zM105.708 104.66h-3.367v3.366h3.367zM1.022.072v22.879H23.9V.072zm19.61 19.61H4.29V3.34h16.342zM86 .072v22.879h22.878V.072zm19.61 19.61H89.268V3.34h16.342zM1.022 85.05v22.878H23.9V85.049zm19.61 19.61H4.29V88.318h16.342z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.364 6.609H7.559v9.805h9.805zM102.341 6.609h-9.805v9.805h9.805zM17.364 91.586H7.559v9.805h9.805z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "507a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.95 0h108v108H.95z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "508b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.95 0h108v108H.95z"
  })))));
});
const SvgAppleStoreQr = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAppleStoreQr);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "cb70e05de9deca246a2e1a6d77254ace.svg";